import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const PmrDistribution = ({
    isLoan,
    isIgr,
    more3mmLegend,
    ICONS_BY_LABEL,
    doughnutData,
    doughnutoptions
}) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="title-components">{t('extended_report.portfolio_distribution_PMR')}</h3>

            <div>
                <p className='ct-pmr'>{t('extended_report.projects_last_validation_cycle')}</p>
            </div>

            {(isLoan | isIgr) ? (
                <div className='clasification-distribution'>
                    <div className='content-projects'>
                        <div>
                            {more3mmLegend.map(({ label, value, color }) => {
                                const Icon = ICONS_BY_LABEL[label];
                                return (
                                    <div key={label}>
                                        <div className='content-distribution legend-circle'>
                                            <div className='legend-circle'>
                                                {Icon && <Icon className='legend-svg' />}
                                            </div>
                                            <p>{label}</p>
                                        </div>
                                        <p className='numberOfProyects'>{`${value} ${t('one_pager_report.projects')}`}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className='doughnut-monitoring'>
                        <Doughnut data={doughnutData} options={doughnutoptions} />
                    </div>

                </div>
            ) : (
                <div className='na-content'>
                    <p>N/A</p>
                </div>
            )}
        </>
    )
}

export default PmrDistribution